import { render, staticRenderFns } from "./CriteriaCollection.vue?vue&type=template&id=605e2986"
import script from "./CriteriaCollection.vue?vue&type=script&lang=js"
export * from "./CriteriaCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports